import gql from "graphql-tag";

const contactQueries = {

    findContact: gql`
        query FindContact($id: ID) {
            contact(id:$id) {
                id
                email
            }
        }
    `,

    findContacts: gql`
        query FindContacts($search: String) {
          findCompany(count: 10, search: $search) {
            data {
              id
              is_company
              first_name
              last_name
              company_name
            }
          }
        }
    `,

    findBuilder: gql`
        query FindCompany($company_name: String) {
          findCompany(
            count: 10,
            company_name: $company_name,
            is_company : 1,
            type_of_relation: "builder"
        ) {
            data {
              id
              is_company
              company_name
              key_contacts# select
              children {
                  id
                  first_name
                  last_name
              }
            }
          }
        }
    `,

    findSubcontractor: gql`
        query FindCompany($company_name: String) {
          findCompany(
            count: 10,
            company_name: $company_name,
            is_company : 1,
            type_of_relation: "subcontractor"
        ) {
            data {
              id
              is_company
              company_name
              email
              street
              number
              zip
              city
            }
          }
        }
    `,

    getSubContractors: gql`
        query Contacts {
            contacts(
            count      : 9999 # paginator
            is_company : 1    # where
            #type_of_relation : "subcontractor"
            orderBy    : [
                { field : "company_name", order : ASC },
            ]
            ){
                data {
                    id
                    company_name
                    email
                }
            }
        }
    `,
};

export default contactQueries;
